import * as Redux from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';

import configEditor from './reducers/config-editor';
import configTester from './reducers/config-tester';
import global from './reducers/global';

const middleware: Redux.Middleware[] = [thunk];

if (process.env.NODE_ENV !== 'production') {
	middleware.push(createLogger());
}

const reducer = Redux.combineReducers<StudioState>({
	configEditor,
	configTester,
	global,
});

export default Redux.createStore<StudioState>(reducer, Redux.applyMiddleware(...middleware));
export {default as globalDispatchToPropsObject} from './actions/global';
export {default as configEditorDispatchToPropsObject} from './actions/config-editor';
export {default as configTesterDispatchToPropsObject} from './actions/config-tester';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/index.ts